import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { ICustomOverridePage, OverridePages } from "../models/pages";

export enum Action {
    EDIT_ORDER = 'edit',
    CONTINUED_ORDER = 'continuation',
    ROUND_TRIP_ORDER = 'roundTrip',
    DUPLICATE_ORDER = 'duplicate',
    SAME_DESTINATION_ORDER = 'sameDestination',
    SAME_ORIGIN_ORDER = 'sameOrigin',
    CREATE_ORDER = 'createOrder'
}

@Injectable({
    providedIn: 'root'
})
export class CustomPageService {
    iframeMessageSource = new BehaviorSubject<any>({});
    iframeMessage$ = this.iframeMessageSource.asObservable();
    constructor() {}

    getStoredPages(): { customPages: ICustomOverridePage[], overridePages: ICustomOverridePage[] } {
        const storedPages = localStorage.getItem('Rapidship:customPages');
        const customPages: any[] = [];
        const overridePages: ICustomOverridePage[] = [];

        if (storedPages) {
            const pages = JSON.parse(storedPages);
             pages.forEach(page => {
                if (page.overridePage === null) {
                    customPages.push(page);
                } else {
                    overridePages.push(page);
                }
            });
        }

        return { customPages, overridePages };
    }

    hasCustomOverride(): boolean {
        const customPages = localStorage.getItem('Rapidship:customPages');
        if (!customPages) {
            return false;
        }
        const pages = JSON.parse(customPages);
        return pages.some(page => page.overridePage !== null);
    }

    getOverridePage(overridePage: OverridePages): ICustomOverridePage {
        const overridePages = this.getStoredPages().overridePages;
        return overridePages.find(page => page.overridePage === overridePage);
    }

    processContextData(iframeId, action, id, token) {
        const getEnumByValue = (value: string): Action | undefined => {
            const keys = (Object.keys(Action) as Array<keyof typeof Action>).filter(x => Action[x] === value);
            return keys.length > 0 ? Action[keys[0]] : undefined;
        };
        const actionEnum = getEnumByValue(action);
        const message = {
            contextData: {
                action: actionEnum,
                id: id
          },
          token: token,
        }
        return message;
    }

}
